import type { Filter } from '@repo/api-codegen';
import type { EdgeTypes, NodeTypes } from '@xyflow/react';
import type { ReactNode } from 'react';
import { ChildEdge } from '../ChildEdge/ChildEdge';
import { EntityEdge } from '../EntityEdge/EntityEdge';
import EntityNode from '../EntityNode/EntityNode';
import { ManualEdge } from '../ManualEdge/ManualEdge';
import TemporaryNode from '../TemporaryNode/TemporaryNode';

export interface LineageFlowProps {
	filters?: ReactNode;
	catalogFilter?: Filter;
	showActionBar?: boolean;
	createAccess?: boolean;
	children?: ReactNode;
}

export const nodeTypes: NodeTypes = {
	ENTITY: EntityNode,
	TEMPORARY: TemporaryNode,
};

export const edgeTypes: EdgeTypes = {
	ENTITY: EntityEdge,
	CHILD: ChildEdge,
	MANUAL: ManualEdge,
};
